'use client'

import { motion, useReducedMotion } from 'framer-motion'
import type { ReactNode } from 'react'

const ease = [0.22, 1, 0.36, 1] as const

type MachuRevealProps = {
  children: ReactNode
  className?: string
}

/**
 * Scroll-triggered fade + lift. Strong enough to read at a glance; respects reduced-motion.
 */
export function MachuReveal({ children, className }: MachuRevealProps) {
  const reduce = useReducedMotion()

  if (reduce) {
    return <div className={className}>{children}</div>
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 52, scale: 0.97 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.15, margin: '0px 0px -5% 0px' }}
      transition={{ duration: 0.78, ease }}
    >
      {children}
    </motion.div>
  )
}
